import { render, staticRenderFns } from "./SupplierRawMaterialStorageShelfLife.vue?vue&type=template&id=44ccf626&scoped=true&"
import script from "./SupplierRawMaterialStorageShelfLife.vue?vue&type=script&lang=js&"
export * from "./SupplierRawMaterialStorageShelfLife.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ccf626",
  null
  
)

export default component.exports